import { Pipe } from '@angular/core';
import type { PipeTransform } from '@angular/core';
import { UtilsService } from '@shared/services';

@Pipe({
    'name': 'myCurrency',
    'standalone': true
    // pure: true
})
export class MyCurrencyPipe implements PipeTransform {
    private utilsService: UtilsService = new UtilsService();

    transform(value: unknown): string {
        const dollars = value as number;

        const str = this.utilsService.formatAsCurrency(dollars);
        return str;
    }
}
